import { render } from "./MinusIcon.vue?vue&type=template&id=d1616a8e"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__